export default __webpack_public_path__ + "static/media/Roboto-Thin.b4d8be96.ttf";